import * as React from 'react';
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import { map } from 'ramda';
import { useDispatch, useSelector } from 'react-redux';

import { setOpenedTableRows } from 'features/common/collapsibleTable/actions';
import { getOpenTableRow } from 'features/common/collapsibleTable/selectors';

export const CollapsibleTable = ({ children, tableHeader, tableBody, tableId, autoCloseOtherRows, sx }) => {
	const dispatch = useDispatch();
	const tableRows = useSelector((state) => getOpenTableRow(state, tableId));

	const changeChildrenVisibility = useCallback(
		(childId) => () => {
			const rows = {
				...map((open) => (autoCloseOtherRows ? false : open), tableRows),
				[childId]: !tableRows[childId],
			};
			dispatch(setOpenedTableRows(tableId, rows));
		},
		[autoCloseOtherRows, tableRows, tableId, dispatch],
	);

	return (
		<Table size="small" sx={{ ...sx }}>
			{tableHeader}
			<TableBody>
				{React.Children.map(tableBody, (child) => {
					return React.cloneElement(child, {
						isDetailVisible: tableRows[child.props.id] || false,
						onDetailVisibilityChange: changeChildrenVisibility(child.props.id),
						...child.props,
					});
				})}
			</TableBody>
			{children}
		</Table>
	);
};

CollapsibleTable.propTypes = {
	autoCloseOtherRows: PropTypes.bool,
	children: PropTypes.any,
	sx: PropTypes.object,
	tableBody: PropTypes.any,
	tableHeader: PropTypes.any,
	tableId: PropTypes.string,
};

export default CollapsibleTable;
